import React from "react";

import Carousel from "@/components/botanic/Carousel";

type ProductsCarouselSkeletonProps = {
  header: React.ReactNode;
};

const Skelements = Array(4).fill(
  <div className="skeleton-card carousel-card carousel-card--quadruplet" />,
);

export const ProductsCarouselSkeleton: React.FC<
  ProductsCarouselSkeletonProps
> = ({ header }) => {
  return (
    <>
      <Carousel title={header} className="my-section">
        {Skelements.map((skelement, index) => (
          <div key={index} data-testid="skeleton-card">
            {skelement}
          </div>
        ))}
      </Carousel>
      <style jsx global>{`
        .skeleton-card {
          display: inline-block;
          position: relative;
          overflow: hidden;
          width: 100%;
          height: 300px;
        }
        .skeleton-card::after {
          position: absolute;
          top: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
          content: "";
          background-image: linear-gradient(
            to right,
            var(--color-leafly-white),
            var(--color-tertiary)
          );
          opacity: 20%;
          transform: translate(0);
          animation: 1.5s loading-placeholder ease-in-out infinite;
        }
        @media (min-width: 1025px) {
          .carousel-card--quadruplet {
            width: 239px;
          }
        }
        @keyframes loading-placeholder {
          0% {
            transform: translate(-100%);
          }
          100% {
            transform: translate(100%);
          }
        }
      `}</style>
    </>
  );
};
